import { render, staticRenderFns } from "./PotensiMainMap.vue?vue&type=template&id=01700184&scoped=true"
import script from "./PotensiMainMap.vue?vue&type=script&lang=js"
export * from "./PotensiMainMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01700184",
  null
  
)

export default component.exports